import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface EmailChangeEvent {
  originalEmailId: string;
  newEmailId: string;
  isEmailAsUserId: boolean;
  source: 'login' | 'contact';
}

@Injectable({ providedIn: 'root' })
export class ProfileEditService {
  private emailChangeSubject = new BehaviorSubject<EmailChangeEvent | null>(null);
  emailChange$ = this.emailChangeSubject.asObservable();

  notifyEmailChange(event: EmailChangeEvent): void {
    this.emailChangeSubject.next(event);
  }

  clearEmailChange(): void {
    this.emailChangeSubject.next(null);
  }
}